import zappy from "@zappy-ride/library.react.components";
import { SmartNextButton } from "./SmartNextButton";

export * from "./SmartNextButton";

zappy.FactoryInstance.registerComponent(SmartNextButton);
